import { BackupVersionError } from '@/errors/backups';
import Image from '@/models/image.model';
import Note from '@/models/note.model';
import Tag from '@/models/tag.model';

export const parseBackup = (version, data) => {
  switch (version) {
    case '0':
    case '1':
      return {
        notes: data.map(note => new Note(note)),
        tags: [],
        images: [],
      };
    case '2':
      return {
        notes: data.notes.map(note => new Note(note)),
        tags: data.tags.map(tag => new Tag(tag)),
        images: [],
      };
    case '3':
    case '4':
      return {
        notes: data.notes.map(note => new Note(note)),
        tags: data.tags.map(tag => new Tag(tag)),
        images: data.images.map(image => new Image(image)),
      };
    default:
      throw new BackupVersionError(version, '4');
  }
};
